if (!customElements.get('product-grid-item')) {
  customElements.define(
    'product-grid-item',
    class ProductGridItem extends HTMLElement {
      selectors = {
        quickAdd: 'data-quick-add',
        singleVariantQuickAdd: 'data-single-variant-quick-add',
      }

      constructor() {
        super();
        this.proxyClickEvent = this.handleProxyClickEvent.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.handleProxyClickEvent);

        if (!this.singleVariantQuickAdd) {
          this.quickAdd.setAttribute('disabled', true);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleProxyClickEvent);
      }

      handleProxyClickEvent(event) {
        if (!this.quickAdd.contains(event.target)) return;

        if (!!this.singleVariantQuickAdd) {
          this.quickAdd.setAttribute('disabled', true);
          this.singleVariantQuickAdd.click();

          // Right here, we need to set a mutation observer
          this.observeSingleVariantQuickAdd(this.singleVariantQuickAdd);
        }
      }

      observeSingleVariantQuickAdd(targetElement) {
        const observerOptions = {
          childList: true,
          attributes: true,
          subtree: true,
          characterData: true,
        };

        // Callback function to execute when mutations are observed
        const callback = (mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.attributeName == 'class' && !mutation.target.classList.contains('btn--loading')) {
              this.quickAdd.removeAttribute('disabled');
              this._mutationObserver.disconnect();
            }
          }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetElement, observerOptions);

        // OPTIONAL: Store the observer if you need to disconnect it later,
        // e.g., in disconnectedCallback or when the relevant operation completes.
        this._mutationObserver = observer;
      }

      get quickAdd() {
        return this.querySelector(`[${this.selectors.quickAdd}]`);
      }

      get singleVariantQuickAdd() {
        return this.querySelector(`[${this.selectors.singleVariantQuickAdd}]`);
      }
    }
  )
}